/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-env browser */
/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import styled, { css } from 'react-emotion';
import ReactImageMagnify from 'react-image-magnify';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';

const MainImage = styled(ReactImageMagnify)`
  cursor: zoom-in !important;
  div {
    z-index: 9999 !important;
  }
  border-width: ${props => props.theme.borders.size.bold + 2}px;
  border-radius: ${props => props.theme.borders.radius.normal}px;

  ${props => props.media.maxMobile && css`
      width: 350px !important;
      height: 350px;
  `};
  ${props => props.media.xsmall && css`
    width: 300px !important;
    height: 300px;
  `};

  .largeImage {
    object-fit: cover !important;
    border-radius: 5px;
    z-index: 1 !important;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #cfcfcf;
    ${props => props.direction === 'rtl'
    && css`
        margin-left: 0 !important;
        left: calc(-100% - 410px) !important;
    `}
    ${cssMediaMax.tablet`
      border: none;
      border-radius: 0;
      box-shadow: none;
    `};
  }
  display: table;
  position: absolute !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  ${cssMediaMax.tablet`
    border: none;
    border-radius: 0;
    box-shadow: none;
  `};
`;
const ImageWrapper = styled.div`
  position: relative;
  width: 400px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  && > img {
    visibility: hidden;
    display: block;
    width: auto;
    max-width: 100%;
    max-height: 100%;
  }
  ${props => props.media.maxMobile
    && css`
      width: 350px;
      height: 350px;
    `}
  ${props => props.media.xsmall
    && css`
      width: 300px;
      height: 300px;
    `}

  ${props => props.media.minDesktop
    && css`
      border-width: ${props.theme.borders.size.thin}px;
      border-style: solid;
      border-color: ${props.theme.borders.color.normal};
      border-radius: ${props.theme.borders.radius.normal}px;
    `}
`;

class SliderMainImage extends Component {
  state = {
    imageWidth: 400,
    imageHeight: 800,
  }

  hidePortalWrapper = () => {
    this.props.portalStatus(false);
  }

  showPortalWrapper = () => {
    this.props.portalStatus(true);
  }

  onImgLoad = ({ target: img }) => {
    this.setState({
      imageWidth: img.offsetWidth,
      imageHeight: img.offsetHeight,
    });
  }

  render = () => {
    const {
       media, largeImage, smallImage, alt,
    } = this.props;
    const { imageHeight, imageWidth } = this.state;
    return (
      <ImageWrapper
        onMouseOver={this.showPortalWrapper}
        onMouseOut={this.hidePortalWrapper}
        media={media}
        alt={alt}
      >
        <img onLoad={this.onImgLoad} src={largeImage} alt={alt} />
        <MainImage
          media={media}
          alt={alt}
          {...
            {
              smallImage: {
                src: smallImage, // this line represet the large image with 400*400 size
                width: imageWidth,
                height: imageHeight,
                alt: alt,
              },
              largeImage: {
                src: largeImage, // this line represet the orignal image with the default size
                width: imageWidth * 3,
                height: imageHeight * 3,
                alt: alt,
              },
              isHintEnabled: true,
              hintTextMouse: i18next.t('ecommerceCoreUI:Product.hoverToZoom'),
              hintTextTouch: i18next.t('ecommerceCoreUI:Product.holdToZoom'),
              shouldHideHintAfterFirstActivation: false,
              enlargedImageContainerDimensions: {
                height: '100%',
                width: '200%',
              },
              lensStyle: { backgroundColor: 'rgba(0,0,0,.5)' },
              enlargedImagePortalId: 'portal',
              enlargedImagePosition: media.minDesktop ? 'beside' : 'over',
              isEnlargedImagePortalEnabledForTouch: false,
              imageStyle: {
                objectFit: 'contain',
              },
              enlargedImageClassName: 'largeImage',
            }
          }
        />
      </ImageWrapper>
    );
  }
}

SliderMainImage.propTypes = {
  media: PropTypes.shape({}).isRequired,
};

export default withMedia(SliderMainImage);
